export enum WebTimeRecordType {
    TERMINAL_COME = 'TERMINAL_COME',
    TERMINAL_LEAVE = 'TERMINAL_LEAVE',
    BUSINESS_ERRAND = 'BUSINESS_ERRAND',
    MOBILE_WORKING_COME = 'MOBILE_WORKING_COME',
    MOBILE_WORKING_LEAVE = 'MOBILE_WORKING_LEAVE'
}
